import { useEffect, useState } from "react";

const apiBaseUrl = process.env.REACT_APP_API_URL;

const PendingJoinRequests = ({ groupId, compact = false, onChanged }) => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchRequests = async () => {
    setLoading(true);
    const token = localStorage.getItem("userToken");
    const params = new URLSearchParams({ status: "pending" });
    if (groupId) params.set("groupId", groupId);
    try {
      const response = await fetch(
        `${apiBaseUrl}/api/participant-group-join-requests?${params}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );
      const body = await response.json();
      setRequests(body.data || []);
    } catch (error) {
      console.error("Failed to load join requests", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRequests();
  }, [groupId]);

  const review = async (id, action) => {
    const token = localStorage.getItem("userToken");
    const response = await fetch(
      `${apiBaseUrl}/api/participant-group-join-requests/${id}/${action}`,
      { method: "POST", headers: { Authorization: `Bearer ${token}` } },
    );
    const body = await response.json().catch(() => ({}));
    if (!response.ok) {
      alert(body.message || "Could not update request.");
      return;
    }
    await fetchRequests();
    onChanged?.();
  };

  if (compact && (loading || requests.length === 0)) return null;

  return (
    <div className="rounded-xl border border-gray-100 bg-white p-5 shadow-lg">
      <div className="mb-4 flex items-center justify-between">
        <div>
          <p className="text-xs font-bold uppercase tracking-wide text-[#004a7e]">
            Approvals
          </p>
          <h3 className="text-lg font-black text-gray-900">
            Pending Group Join Requests
          </h3>
        </div>
        {loading && <span className="text-sm text-gray-400">Loading…</span>}
      </div>
      {requests.length === 0 ? (
        <p className="text-sm text-gray-500">No pending join requests.</p>
      ) : (
        <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
          {requests.map((request) => (
            <div
              key={request.id}
              className="rounded-lg border border-gray-100 p-4"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="min-w-0">
                  <p className="font-bold text-gray-900">{request.name}</p>
                  {!groupId && (
                    <p className="text-xs font-semibold text-[#004a7e]">
                      {request.groupName}
                    </p>
                  )}
                  <p className="text-sm text-gray-500">{request.phone}</p>
                  <p className="text-sm text-gray-500">{request.email}</p>
                  <p className="mt-1 text-sm text-gray-600">
                    {request.rideLocation}
                  </p>
                </div>
              </div>
              <div className="mt-4 flex gap-2">
                <button
                  className="rounded-lg bg-[#004a7e] px-3 py-2 text-sm font-bold text-white"
                  onClick={() => review(request.id, "approve")}
                >
                  Approve
                </button>
                <button
                  className="rounded-lg border border-gray-300 px-3 py-2 text-sm font-bold text-gray-700"
                  onClick={() => review(request.id, "reject")}
                >
                  Reject
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PendingJoinRequests;
